<template>
  <aside
    v-if="visible"
    class="plants-contributor-popup"
    role="dialog"
    :aria-labelledby="titleId"
    :aria-describedby="textId"
  >
    <div class="plants-contributor-popup__inner">
      <p class="plants-contributor-popup__title" :id="titleId">{{ $t('contributor_popup_title') }}</p>
      <p class="plants-contributor-popup__text" :id="textId" v-html="$t('contributor_popup_text')"></p>
      <p class="plants-contributor-popup__cta">
        <a class="plants-contributor-popup__link" :href="mailtoLink">{{ $t('contributor_popup_contact') }}</a>
        ·
        <button type="button" class="plants-contributor-popup__link-btn" @click="openReport">
          {{ $t('contributor_popup_report') }}
        </button>
      </p>
      <button
        type="button"
        class="plants-contributor-popup__close"
        :aria-label="$t('contributor_popup_close')"
        @click="dismiss"
      >&times;</button>
    </div>
  </aside>
</template>

<script>
import { usePlantStore } from '@/stores/plant-store'

const STORAGE_KEY = 'plants4pets_contributor_popup_dismissed'

export default {
  data () {
    return {
      visible: false,
      titleId: 'plants-contributor-popup-title-vue',
      textId: 'plants-contributor-popup-text-vue'
    }
  },
  computed: {
    mailtoLink () {
      const subject = this.$i18n.locale === 'en'
        ? 'Plants4Pets - join as contributor'
        : 'Plants4Pets - współpraca'
      return 'mailto:kontakt@plants4pets.pl?subject=' + encodeURIComponent(subject)
    }
  },
  mounted () {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === '1') {
        return
      }
    } catch (e) {}
    this.visible = true
  },
  methods: {
    dismiss () {
      this.visible = false
      try { sessionStorage.setItem(STORAGE_KEY, '1') } catch (e) {}
    },
    openReport () {
      usePlantStore().selected_plant = null
      this.$bvModal.show('plant-modal')
    }
  }
}
</script>
